import React from "react";
import { Field, ErrorMessage } from "formik";
import { TextError } from "../../../../componenets/TextError";

const SelectData = (props) => {
  const { label, name, options, countryobj, ...rest } = props;
  return (
    <>
      {countryobj ? null : <label htmlFor={name}>{label}</label>}

      <Field
        as="select"
        id={name}
        name={name}
        {...rest}
        className="form-control"
      >
        {options.map((curr, index) => {
          return (
            <option key={curr.id} value={curr.id}>
              {curr.name}
            </option>
          );
        })}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </>
  );
};

export default SelectData;
